// setTimeout(function(){
//   if ($(window).width() > 1100) { 


//   $("#cart-icon-bubble").hover(
//     function () {
//       $('.cv-ajaxcart-popup').addClass('active_cart_drawer');
//       $('.cv-ajaxcart-popup').addClass('active_cart_drawerer');
//     },
//     function () {
//       $('.cv-ajaxcart-popup').removeClass('active_cart_drawer');
//       $('.cv-ajaxcart-popup').removeClass('active_cart_drawerer');

//     }
//   );

//   $(".cv-ajaxcart-popup").hover(
// function () {
//       $('.cv-ajaxcart-popup').addClass('active_cart_drawer');
//       $('.cv-ajaxcart-popup').addClass('active_cart_drawerer');
//     },
//     function () {
//       $('.cv-ajaxcart-popup').removeClass('active_cart_drawer');
//       $('.cv-ajaxcart-popup').removeClass('active_cart_drawerer');
//     }
//   );
//     }
// }, 2000);

$(document).on("click","#cart-icon-bubble", function(event){
     event.stopPropagation();
$('.cv-ajaxcart-popup').toggleClass('active_cart_drawer');
$('.cv-ajaxcart-popup').toggleClass('active_cart_drawerer'); 
});
$(document).on('click',"body", function(event) {
if (!$(event.target).closest('.cv-ajaxcart-popup').length)  {
$('.cv-ajaxcart-popup').removeClass('active_cart_drawer');
$('.cv-ajaxcart-popup').removeClass('active_cart_drawerer');
}
});
$(document).on("click",".close-CartDrawer",function() {
$('.cv-ajaxcart-popup').removeClass('active_cart_drawer');
$('.cv-ajaxcart-popup').removeClass('active_cart_drawerer'); 
});
$(document).on("click",".spf-product__form-btn-addtocart",function(e) {
  e.preventDefault()
  var var_id = $(this).closest('form').serialize();
  $(this).parents('.spf-product-card').find('.spf-product__swatchs_container').children('p').addClass('text_changep').text('Adding to bag');

  $.ajax({
    url:'/cart/add',
    type:'POST',
    dataType: 'HTML',  
    data:var_id,
    success: function(response){
      $('.text_changep').text('Item Added to bag');
      $('#cvform2').load('#cvform2');
      $('.se_op_pl').html($(response).filter('.se_op_pl').html());
      $('.header-cart__count').html($(response).find('.header-cart__count').html()); 
      $('.cv-ajaxcart-popup').addClass('active_cart_drawerto');
      $('.cv-ajaxcart-popup').addClass('active_cart_drawer');
      setTimeout(function(){
        $('.text_changep').text('Add To Bag');
        $('.cv-ajaxcart-popup').removeClass('active_cart_drawerto');
        $('.cv-ajaxcart-popup').removeClass('active_cart_drawer');
      }, 3000);
    },
    error: function () { 
      alert('Item out of stock');
      $('.text_changep').text('Add To Bag');
    }

  });

});


$(document).on('click touchstart','.cart__removedc',function(e){
  e.preventDefault();
  var url = $(this).attr('href');
  $.ajax({
    url:url,
    type:'GET',
    success: function(response){
      $('#cvform2').load('#cvform2');
      $('.se_op_pl').html($(response).filter('.se_op_pl').html());
      $('.header-cart__count').html($(response).find('.header-cart__count').html()); 
      $('.cv-ajaxcart-popup').addClass('active_cart_drawer');
      $('.cv-ajaxcart-popup').addClass('active_cart_drawerer');
    }
  });
});


/*********************** 21/3/22 **********************/

$('.cart-notification__close').click(function(){
  $('.cart-notification').hide();
});


$(document).on("click","button.cart-notification__close.modal__close-button",function(e) {

$('.cart-notification').removeClass('active');
    
});
$(document).on("click",".pop_overlay",function(e) {

$('.cart-notification').removeClass('active');
    
});